import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid, theme } from "antd";
import {
  DashboardOutlined,
  AppstoreOutlined,
  InboxOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { useBreakpoint } = Grid;

interface NavItem {
  key: string;
  path: string;
  icon: React.ReactNode;
  labelKey: string;
}

const NAV_ITEMS: NavItem[] = [
  {
    key: "dashboard",
    path: "/dashboard",
    icon: <DashboardOutlined />,
    labelKey: "navigation.dashboard",
  },
  {
    key: "lists",
    path: "/Lead",
    icon: <AppstoreOutlined />,
    labelKey: "bottomNav.lists",
  },
  {
    key: "inbasket",
    path: "/inbasket",
    icon: <InboxOutlined />,
    labelKey: "navigation.inbasket",
  },
  {
    key: "profile",
    path: "/profile",
    icon: <UserOutlined />,
    labelKey: "navigation.profile",
  },
];

export const BottomNavBar: React.FC = () => {
  const screens = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { token } = theme.useToken();

  // Only show on mobile (below md breakpoint)
  if (screens.md) {
    return null;
  }

  const getActiveKey = (): string => {
    const path = location.pathname;
    if (path === "/dashboard") return "dashboard";
    if (path === "/inbasket") return "inbasket";
    if (path === "/profile") return "profile";
    return "lists";
  };

  const activeKey = getActiveKey();

  return (
    <>
      {/* Spacer to prevent content overlap */}
      <div
        style={{ height: "calc(56px + env(safe-area-inset-bottom, 0px))" }}
      />
      <nav
        data-testid="bottom-nav"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: "calc(56px + env(safe-area-inset-bottom, 0px))",
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
          backgroundColor: token.colorBgContainer,
          borderTop: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.06)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          zIndex: 1000,
        }}
      >
        {NAV_ITEMS.map((item) => {
          const isActive = activeKey === item.key;
          return (
            <button
              key={item.key}
              onClick={() => navigate(item.path)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                flex: 1,
                height: "100%",
                border: "none",
                background: "none",
                cursor: "pointer",
                color: isActive ? token.colorPrimary : token.colorTextSecondary,
                fontSize: 10,
                padding: 0,
                transition: "color 0.2s ease",
              }}
            >
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              <span>{t(item.labelKey)}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
};
